import api from 'api'
import { get } from 'lodash'

export function fetchCredits() {
  return dispatch => {
    api.get('promos/credit_balance')
      .then(res => {
        dispatch({ type: 'SET_CREDITS', data: { default: Number(res.data.amount) } })
      })
      .catch(() => {
        dispatch({ type: 'SET_CREDITS', data: { default: 0 } })
      })
  }
}

export function applyPromoCode(code) {
  return dispatch => api.post('promos/activations', { promo_code: code })
    .then(res => {
      const creditsRemaining = get(res, 'data.credits_remaining')
      dispatch({ type: 'SET_CREDITS', data: { default: Number(creditsRemaining) } })
      const flash = { type: 'success', message: 'Promotion successfully redeemed' }
      return Promise.resolve(flash)
    })
    .catch(err => {
      const errors = get(err, 'response.data.errors')
      const flash = { message: 'The submitted code could not be validated at this time', type: 'error' }
      
      if (Array.isArray(errors)) {
        const message = get(err, 'response.data.errors[0].message')
        
        if (message === 'Promocode is invalid') { 
          flash.message = 'Please enter a valid promotion code'
        } else {
          flash.message = message
          flash.type = 'alert'
        }
      }

      return Promise.reject(flash)
    })
}